<div class="app-modal-spinner">
  <div class="spinner-section" *ngIf="isLoading">
    <ng-container>
      <div class="spinner-container-sched">
        <mat-spinner diameter="40" aria-label="読み込み中"></mat-spinner>
      </div>
    </ng-container>
  </div>
  <div>
    <header class="edit-header">
      <h1>{{ displayName }}</h1>
    </header>
    <div class="container">
      <span class="username">{{ user.name }}</span>
      <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <ul *ngIf="records" class="record-list">
          <li *ngFor="let record of records; index as i">
            <app-record-field
              [staffList]="scheduleService.setDefaultStaff(record, staffList)"
              [record]="record"
              [form]="getRecordForm(i)"
              [isDelete]="recordService.isDelete(record.delstat)"
            >
              <app-record-delete
                [disabled]="recordService.isDelete(record.delstat)"
                (delete)="delete(record, i)"
              ></app-record-delete>
            </app-record-field>
          </li>
        </ul>
        <button
          type="button"
          mat-stroked-button
          class="add-button"
          (click)="addRecord()"
        >
          記録を追加<mat-icon svgIcon="plus"></mat-icon>
        </button>
        <app-edit-footer
          [navigationFinally]="historyBackWard"
          excuteText="保存"
          [disabled]="form.invalid"
        ></app-edit-footer>
      </form>
    </div>
  </div>
</div>
